import React, { useEffect, useState } from 'react';
import './Trial.css';
import Form from '../Form/Form';
import TestimonialCard from '../TestimonialCard/TestimonialCard';
import backgroundImage from '../../../../../assets/FormBackImg.webp';
import mobileViewTrial from '../../../../../assets/mobileViewTrial.svg';
// import {defaultTestimonials} from '../../../../../data';
import { fetchTestimonials } from '../../../../../services/radix/radixServices';
const Trial = ({ TestimonialCards }) => {
    
    const [testimonials, SetTestimonial]=useState([]);
    useEffect(()=>{
        const loadTestimonial=async()=>{
        const data=await fetchTestimonials();
        SetTestimonial(data);
        }
        loadTestimonial();
    },[])

    return (
        <div className="Trial">
            <div className="header-h1">
                <h1>Unlock Your Free Trial of<br />Powerful Accounting Software Today!</h1>
            </div>
            <div className="content">
                <div className="background">
                    <img src={mobileViewTrial} className="screen-image mobile" alt="MobileBackground" />
                    <img src={backgroundImage} className="screen-image pc" alt="Background" />
                    <div className="form-overlay">
                        <Form />
                    </div>
                    
                    <div className="testimonials">
                        {testimonials.length > 0 ? (
                            testimonials.map((testimonial) => (
                                <TestimonialCard 
                                    key={testimonial.id} 
                                    className={testimonial.Slug} 
                                    name={testimonial.Name} 
                                    feedback={testimonial.Feedback} 
                                />
                            ))
                        ) : (
                            <p>No testimonials available.</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Trial;
